import { isFreshThisSeason } from './processorFreshness';
import { driveMinutes, milesBetween } from './processorSearch';
import { parseGoogleMapsPlaceUrl } from '../../../services/geocodingService';

export const PROCESSOR_SOURCE_ALL = 'all';
export const PROCESSOR_SOURCE_YONA = 'yona';
export const PROCESSOR_SOURCE_PLACE = 'place';

export const PROCESSOR_SERVICE_OPTIONS = [
  'SKINNING',
  'CUT SHEET',
  'SAUSAGE',
  'JERKY',
  'CAPE FOR MOUNT',
  'HOG',
  'VACUUM SEAL',
  'AFTER-HOURS COOLER',
];

export function isProcessorTraceEnabled(windowRef = typeof window !== 'undefined' ? window : undefined) {
  if (!windowRef?.location) return false;
  try {
    const params = new URLSearchParams(windowRef.location.search || '');
    if (params.get('debug') === '1') return true;
    return windowRef.localStorage?.getItem('yona-debug') === '1';
  } catch {
    return false;
  }
}

export function filterAndSortProcessors({
  rows = [],
  origin,
  radiusMiles,
  source = PROCESSOR_SOURCE_ALL,
  confirmedThisSeason = false,
} = {}) {
  if (!origin || !Number.isFinite(origin.latitude) || !Number.isFinite(origin.longitude)) {
    return [];
  }
  const radius = Number(radiusMiles);
  return rows
    .map((row) => {
      const miles = milesBetween(origin.latitude, origin.longitude, row.latitude, row.longitude);
      return {
        ...row,
        miles,
        drive_minutes: driveMinutes(miles),
      };
    })
    .filter((row) => Number.isFinite(row.miles) && (!Number.isFinite(radius) || row.miles <= radius))
    .filter((row) => source === PROCESSOR_SOURCE_ALL || row.source === source)
    .filter((row) => !confirmedThisSeason || isFreshThisSeason(row.freshness))
    .sort((a, b) => a.miles - b.miles);
}

export function processorSourceLabel(row) {
  if (row?.source === 'yona') return 'YONA DIRECTORY';
  const via = row?.via || 'MAP DATA';
  return `NEARBY PLACE · ${via}`;
}

export function processorCheckInLabel(count) {
  const n = Number(count) || 0;
  return n > 0 ? `${n} CHECK-INS` : 'NO CHECK-INS';
}

export function processorTelHref(phone) {
  const digits = String(phone || '').replace(/[^0-9+]/g, '');
  return digits ? `tel:${digits}` : 'tel:';
}

export function processorDirectionsUrl(row) {
  const pin = processorDirectionsPin(row);
  if (pin) {
    return mapsDirUrl(`${pin.latitude},${pin.longitude}`);
  }
  const mapsUrl = String(row?.maps_url || '').trim();
  if (/^https?:\/\//i.test(mapsUrl)) {
    return mapsUrl;
  }
  const destination = [String(row?.address || '').trim(), String(row?.town || '').trim()]
    .filter(Boolean)
    .join(', ');
  return mapsDirUrl(destination || 'United States');
}

function processorDirectionsPin(row) {
  const latitude = Number(row?.latitude);
  const longitude = Number(row?.longitude);
  if (Number.isFinite(latitude) && Number.isFinite(longitude) && !(latitude === 0 && longitude === 0)) {
    return { latitude, longitude };
  }
  return parseGoogleMapsPlaceUrl(row?.maps_url);
}

function mapsDirUrl(destination) {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}

export function processorPhoneDisplay(phone) {
  const text = String(phone || '').trim();
  return text || 'No number on file — try directions and ask';
}

export function processorAddressDisplay(row) {
  const address = String(row?.address || '').trim();
  const town = String(row?.town || '').trim();
  if (address && town && !address.toLowerCase().includes(town.toLowerCase())) {
    return `${address}, ${town}`;
  }
  return address || town || 'No street address on file';
}
